/*
 * CA-16 Natulim DB — Reconciliación del regalo del Build-a-Box (FR).
 * En PT/PL este regalo lo gestionaba la app JUO en servidor. FR se construyó
 * sin esa app: el regalo se añade una sola vez al pulsar "Ajouter au panier"
 * y nunca se revisa después. Si el cliente lo borra a mano desde el carrito,
 * o quita productos del box hasta bajar del mínimo, el regalo queda huérfano
 * (persiste indefinidamente, incluso tras cerrar el carrito o recargar).
 *
 * Este script solo se carga en páginas con un bloque Build-a-Box que tenga
 * regalo configurado (bab_gift_from > 0).
 *
 * El carrito visible para el cliente en esta tienda no es el cart-drawer
 * nativo del tema: la app UpCart renderiza su propio drawer dentro de un
 * Shadow DOM (#upCart), con su propio botón de borrar y su propio sistema
 * de eventos (aftersell-upcart:public-events:*), completamente aislado del
 * PUB_SUB_EVENTS.cartUpdate del tema. Verificado en vivo: borrar una línea
 * desde el drawer de UpCart SÍ modifica el carrito real (/cart.js), pero
 * NUNCA dispara PUB_SUB_EVENTS.cartUpdate, así que la reconciliación no se
 * enteraba hasta la siguiente carga de página. Por eso, además de escuchar
 * ese evento nativo, interceptamos fetch() para detectar CUALQUIER llamada
 * a /cart/add|change|update|clear.js — venga de UpCart, de la app de puntos
 * (points-and-rewards.js), o de cualquier otra— y añadimos un polling ligero
 * como red de seguridad final para lo que use XMLHttpRequest en vez de
 * fetch.
 */
(function () {
  function getBoxData() {
    const el = document.getElementById("juo-box-data");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  const boxData = getBoxData();
  if (
    !boxData ||
    !boxData.product ||
    !boxData.freeProduct ||
    !boxData.freeProduct.id ||
    !(boxData.freeProductFrom > 0)
  ) {
    return;
  }

  const boxTag = `box-${boxData.product.id}`;
  const giftVariantId = Number(boxData.freeProduct.id);
  let syncing = false;

  function root() {
    return (
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/"
    );
  }

  function lineVariantId(item) {
    return Number(item.variant_id != null ? item.variant_id : item.id);
  }

  function findGiftLine(items) {
    return items.find(
      (item) =>
        item.properties &&
        item.properties._box === boxTag &&
        lineVariantId(item) === giftVariantId
    );
  }

  function boxQuantity(items) {
    return items.reduce((sum, item) => {
      if (
        item.properties &&
        item.properties._box === boxTag &&
        lineVariantId(item) !== giftVariantId
      ) {
        return sum + item.quantity;
      }
      return sum;
    }, 0);
  }

  function sectionsToRender() {
    const cartDrawer = document.querySelector("cart-drawer");
    return cartDrawer && typeof cartDrawer.getSectionsToRender === "function"
      ? cartDrawer.getSectionsToRender().map((s) => s.id)
      : [];
  }

  function refreshDrawer(parsedState) {
    if (!parsedState) return;
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.renderContentsNoOpen === "function") {
      cartDrawer.renderContentsNoOpen(parsedState);
    }
    // El carrito visible al cliente en esta tienda es el drawer de UpCart
    // (Shadow DOM, #upCart), no el cart-drawer nativo del tema. UpCart no
    // se entera de cambios hechos por fetch() ajenos a su propio bundle,
    // así que hay que pedirle explícitamente que se refresque.
    if (typeof window.upcartRefreshCart === "function") {
      window.upcartRefreshCart().catch(() => {});
    }
    if (typeof publish === "function") {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "juo-bab-gift-sync",
        cartData: parsedState,
      });
    }
  }

  function addGift() {
    syncing = true;
    fetch(`${root()}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Juo-Bab-Gift-Sync": "1",
      },
      body: JSON.stringify({
        items: [
          {
            id: giftVariantId,
            quantity: 1,
            properties: {
              _box: boxTag,
              _parent_product_handle: boxData.product.handle,
            },
          },
        ],
        sections: sectionsToRender(),
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then(refreshDrawer)
      .catch(() => {})
      .finally(() => {
        syncing = false;
      });
  }

  function removeGift(giftLine) {
    syncing = true;
    fetch(`${root()}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Juo-Bab-Gift-Sync": "1",
      },
      body: JSON.stringify({
        id: giftLine.key,
        quantity: 0,
        sections: sectionsToRender(),
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then(refreshDrawer)
      .catch(() => {})
      .finally(() => {
        syncing = false;
      });
  }

  function reconcile(items) {
    if (syncing || !items) return;
    const giftLine = findGiftLine(items);
    const qty = boxQuantity(items);
    const shouldHaveGift = qty >= boxData.freeProductFrom;
    if (shouldHaveGift && !giftLine) {
      addGift();
    } else if (!shouldHaveGift && giftLine) {
      removeGift(giftLine);
    }
  }

  function reconcileFromCartJson() {
    fetch(`${root()}cart.js`, { cache: "no-store" })
      .then((r) => r.json())
      .then((cart) => reconcile(cart.items))
      .catch(() => {});
  }

  if (typeof subscribe === "function") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === "juo-bab-gift-sync") return;
      if (event && event.cartData && event.cartData.items) {
        reconcile(event.cartData.items);
      } else {
        reconcileFromCartJson();
      }
    });
  }

  // Intercepta fetch() para detectar mutaciones del carrito hechas por
  // OTRAS apps (UpCart, Abra, etc.) que no pasan por PUB_SUB_EVENTS.
  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (typeof window.fetch === "function" && !window.__juoBabGiftSyncFetchPatched) {
    window.__juoBabGiftSyncFetchPatched = true;
    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
      const url =
        typeof input === "string" ? input : (input && input.url) || "";
      const isOwnCall =
        init && init.headers && init.headers["X-Juo-Bab-Gift-Sync"];
      const result = originalFetch.apply(this, arguments);
      if (!isOwnCall && CART_MUTATION_RE.test(url)) {
        result.then(() => {
          setTimeout(reconcileFromCartJson, 300);
        }).catch(() => {});
      }
      return result;
    };
  }

  // Red de seguridad final: cualquier mutación que no use fetch() (p. ej.
  // XMLHttpRequest) se acaba detectando por polling, sin esperar a recargar
  // la página.
  const POLL_INTERVAL_MS = 6000;
  setInterval(() => {
    if (document.visibilityState === "visible") {
      reconcileFromCartJson();
    }
  }, POLL_INTERVAL_MS);

  reconcileFromCartJson();
})();
